"use strict";
/**
 * Docs for text-overflow -> ellipsis:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisThreeLines = exports.EllipsisOneLine = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.EllipsisOneLine = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
exports.EllipsisThreeLines = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=typography.js.map